import * as types from './mutation_types'
import axios from 'axios'
import { ENTRYPOINT } from '../../../config/entrypoint'

export const addNewSchema = async ({commit}, data) => {
  try {
    commit(types.IS_LOADING_SCHEMA, true)
    const res = await axios({ url: ENTRYPOINT + '/api/schema-fonctionnel/ajout', data, method: 'POST' })
    const { id, nom } = res.data.data
    commit(types.ADD_TO_LIST_SCHEMA, {id, nom})
    commit(types.IS_LOADING_SCHEMA, false)
    return 'Schéma créé'
  } catch (err) {
    return 'Erreur lors de la création du schéma'
  }
}

export const listAllSchema = async ({commit}, projectId) => {
  try {
    commit(types.IS_LOADING_SCHEMA, true)
    const res = await axios({ url: ENTRYPOINT + '/api/schema-fonctionnel/liste/' + projectId, method: 'GET' })
    const { schemasFonctionnels } = res.data.data
    commit(types.POPULATE_LIST_SCHEMA, schemasFonctionnels)
    commit(types.IS_LOADING_SCHEMA, false)
  } catch (err) {
    return err.response.data.message + ''
  }
}

export const listAllInvitedSchema = async ({commit}, payload) => {
  try {
    commit(types.IS_LOADING_SCHEMA, true)
    const res = await axios({ url: ENTRYPOINT + '/invite/schema-fonctionnel/liste/' + payload.idProject + '?invitation=' + payload.idInvitation, method: 'GET' })
    const { schemasFonctionnels } = res.data.data
    commit(types.POPULATE_LIST_SCHEMA, schemasFonctionnels)
    commit(types.IS_LOADING_SCHEMA, false)
  } catch (err) {
    return err.response.data.message + ''
  }
}

export const renameSchema = async ({commit}, data) => {
  try {
    commit(types.IS_LOADING_SCHEMA, true)
    const res = await axios({ url: ENTRYPOINT + '/api/schema-fonctionnel/modification-nom/' + data.schemaId, data: {nom: data.nom}, method: 'POST' })
    const { id, nom } = res.data.data
    commit(types.ADD_TO_LIST_SCHEMA, {id, nom})
    commit(types.IS_LOADING_SCHEMA, false)
    return 'Schéma modifiéé'
  } catch (err) {
    return err.response.data.message + ''
  }
}

export const deleteSchema = async ({commit}, schemaId) => {
  try {
    commit(types.IS_LOADING_SCHEMA, true)
    await axios({ url: ENTRYPOINT + '/api/schema-fonctionnel/supprime/' + schemaId, method: 'DELETE' })
    commit(types.DELETE_FROM_LIST_SCHEMA, schemaId)
    commit(types.IS_LOADING_SCHEMA, false)
  } catch (err) {
    return err.response.data.message + ''
  }
}

export const clearListSchema = ({commit}) => {
  commit(types.POPULATE_LIST_SCHEMA, [])
}

export const setCurrentSelection = ({commit}, value) => {
  commit(types.SET_CURRENT_SELECTION, value)
}

export const setCurrentSchema = ({commit}, value) => {
  commit(types.SET_CURRENT_SCHEMA, value)
}

export const getSchemaData = async ({commit}, schemaId) => {
  try {
    commit(types.IS_LOADING_SCHEMA, true)
    const res = await axios({ url: ENTRYPOINT + '/api/schema-fonctionnel/details/' + schemaId, method: 'GET' })
    return res.data.data.data
  } catch (err) {
    return err.response.data.message + ''
  } finally {
    commit(types.IS_LOADING_SCHEMA, false)
  }
}

export const getInviteSchemaData = async ({commit}, schemaId) => {
  try {
    commit(types.IS_LOADING_SCHEMA, true)
    const res = await axios({ url: ENTRYPOINT + '/invite/schema-fonctionnel/details/' + schemaId, method: 'GET' })
    return res.data.data.data
  } catch (err) {
    return err.response.data.message + ''
  } finally {
    commit(types.IS_LOADING_SCHEMA, false)
  }
}

export const saveSchemaData = async ({commit}, payload) => {
  try {
    commit(types.IS_LOADING_SCHEMA, true)
    const asyncUpdates = payload.tableauUpdate.map(el => {
      axios({ url: ENTRYPOINT + '/api/tableau-surface/onglet/modification/' + el.id, data: el, method: 'POST' })
    })
    await Promise.all(asyncUpdates)
    await axios({ url: ENTRYPOINT + '/api/schema-fonctionnel/modification/' + payload.schemaId, data: {data: payload.data}, method: 'POST' })
    return 'Sauvegardé'
  } catch (err) {
    return err.response.data.message + ''
  } finally {
    commit(types.IS_LOADING_SCHEMA, false)
  }
}

export const setAction = ({commit}, value) => {
  commit(types.SET_ACTION, value)
}

export const setLayerTree = ({commit}, value) => {
  commit(types.SET_LAYER_TREE, value)
}



// WEBPACK FOOTER //
// ./src/store/modules/schemaFonctionnel/actions.js